import { Checkbox, TableBody, TableCell, Avatar } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { NoDataFound } from '../../components/NoDataFound'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useSalesChannelType } from '../../hooks/CompanyConfiguration/useSalesChannelType'

import { formatDate, handleSelectAllClick, isValidUrl, handleSelectedItem, isSelected, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'

function SalesChannelTypes() {
  const { salesChannelTypes } = useContext(ConfigurationContext)
  const { getAllSalesChannelType, deleteSalesChannelType, deleteManySalesChannelType, BulkUpload, loading, paginate, pdfCsvData } = useSalesChannelType()

  const [searchQuery, setSearchQuery] = useState('')

  const filterSalesChannelType = salesChannelTypes
    ? salesChannelTypes.filter((salesChannelType) => salesChannelType && salesChannelType.name && salesChannelType.name.toLowerCase().includes(searchQuery.toLowerCase()))
    : []
  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const noOfPages = paginate && paginate.totalPage
  //console.log('SELECTED ITEM : ', selected)
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const handlePageChange = (event, value) => {
    console.log("PAGE", value);
    setPage(value)
  }
  useEffect(() => {
    getAllSalesChannelType({ page: page, limit : 15, searchQuery : searchQuery })
  }, [page])

  return (
    <Layout
      heading="Sales Channel Type"
      url={ROUTES.ADD_SALES_CHANNEL_TYPE}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/edit-salesChannelType/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      none
      addnone
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      filename= 'salesChannelTypes'
      sampleName= 'sample_sales_channel'
      sheetName= 'salesChannelTypes'
      page= {page}
      setPage = {setPage}
      handlePageChange={handlePageChange}
      paginate={{ totalPage: 100, page: page }}
      tempHeaders = {["channelType", "name", "companyName", "remarks", "email", "contact", "address", "shopImg", "businessCardImg",]}
      tempHeaderData = {[["Supply", "supply2", "Kohler", "some reviews about the place and channel", "kohler@gmail.com", "9999988888", "Noida sector 14, shiv appartment", "image Url", "image Url", ]]}
      headers= {pdfCsvData.headings}
      data= {pdfCsvData.headingValues}
    >
      <CustomTable>
        {filterSalesChannelType.length > 0 && (
          <CustomTableHeading
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < filterSalesChannelType.length}
                checked={filterSalesChannelType.length > 0 && selected.length === filterSalesChannelType.length}
                onClick={(event) => handleSelectAllClick(event, filterSalesChannelType, setSelected)}
              />,
              'channel name',
              'sales channel name',
              // 'category',
              // 'sub category',
              'company name',
              'email',
              'contact', 
              'address',
              'business image',
              'shop image',
              'remarks',
              'created date',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            filterSalesChannelType.length > 0 &&
            filterSalesChannelType.map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow>
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>

                  <TableCell>{item.channelType?.name}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  {/* <TableCell>{item.category?.categoryName}</TableCell>
                  <TableCell>{item.subCategory?.name}</TableCell> */}
                  <TableCell>{item.companyName}</TableCell>
                  <TableCell>{item.email}</TableCell>
                  <TableCell>{item.contact}</TableCell>
                  <TableCell>{item.address}</TableCell>
                  <TableCell> {isValidUrl(item.businessCardImg) ? <Avatar src={item.businessCardImg} profile style={{ cursor: 'pointer', justifyContent: "center", margin: "auto" }} /> : "No Img"}</TableCell>
                  <TableCell> {isValidUrl(item.shopImg) ? <Avatar src={item.shopImg} profile style={{ cursor: 'pointer', justifyContent: "center" }} /> : "No Img"}</TableCell>
                  <TableCell>{item.remarks}</TableCell>
                  <TableCell>{formatDate(item.createdAt)}</TableCell>
                  
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ConfirmDialog
        open={deleteDialog}
        handleClose={() => setDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteSalesChannelType({ salesChannelTypeId: selected[0]._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManySalesChannelType({ salesChannelTypeId: multipleId }, setSelected)}
      />
      {!loading && filterSalesChannelType.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handlePageChange} paginate={{ totalPage: 100, page: page }}
 />}
      {loading && <Loader />}
      {!loading && !filterSalesChannelType.length && <NoDataFound />}
    </Layout>
  )
}

export default SalesChannelTypes
